import { create } from 'zustand'

const useInvoiceActionStore = create((set) => ({
  pendingIADialog: null,
  setPendingIADialog: (data) => set({ pendingIADialog: data }),
  invoice_data: {},
  setInvoiceData: (data) => set({ invoice_data: data }),
  action: null,
  setAction: (data) => set({ action: data }),
}))

export default useInvoiceActionStore;